<a
    [routerLink]="['/', 'resume', 'overview']"
    routerLinkActive="app__subnav__active">
    <img
        src="../../../assets/img/logo.svg"
        class="login__logo m-b-2" />
</a>
